var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCrown = function SvgCrown(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#71717A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.024 17.917a17.158 17.158 0 0 0-12.048 0m12.642-3.16 2.07-8.974c.12-.513-.508-.86-.881-.488-2.13 2.129-5.742 1.387-6.86-1.409l-.638-1.593a.333.333 0 0 0-.618 0l-.638 1.593c-1.118 2.796-4.731 3.538-6.86 1.409-.373-.373-1-.025-.882.488l2.07 8.973c4.268-1.6 8.97-1.6 13.237 0Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCrown);
export default ForwardRef;